import React, { useContext } from 'react';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { Modal } from '../../../../components/containers/Modal';
import { BeaconContext } from '../../../../providers/BeaconProvider';

export type DeletePostingPlanModalViewProps = {
  onClose: () => void;
  onSubmit: () => void;
};

export const DeleteTimeslotModalView = (props: DeletePostingPlanModalViewProps): JSX.Element => {
  const { beacon } = useContext(BeaconContext);
  return (
    <Modal
      closeOnClickOutside={true}
      closeOnEsc={true}
      onClose={props.onClose}
      showCloseIcon={true}
      title={'Confirm Deletion'}
      primaryButtonTitle={'Delete Timeslot'}
      primaryButtonAction={props.onSubmit}
      primaryButtonColor={ButtonColorsEnum.alert}>
      The Timeslot you are about to delete may have queued Posts that use it. If you delete it, those Posts will not be
      published, and will be moved to the Unqueued filter. <a onClick={() => beacon('article', '697', { type: 'modal' })}>Learn more</a>
    </Modal>
  );
};
